import {
  ICalculationResult,
  ILenderProduct,
  IRepaymentCalculationRequest,
  ISwitcherCalculationRequest,
  ProductCategory,
} from "../models/CalculatorModels";
import { NumberAsCurrency } from "../components/NumberAsCurrency";
import axios from "axios";
import { PortalPage } from "../components/PortalPage";
import "./Calculators.css";
import {
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Stack,
} from "react-bootstrap";
import { UserContextComponent } from "../components/UserContextComponent";
import { CalculatedLenderProductRow } from "../components/Cards/CalculatedLenderProductRow";
import { Link } from "react-router-dom";
import { AppointSolicitorTile } from "../components/Tiles/AppointSolicitorTile";
import { LifeCoverTile } from "../components/Tiles/LifeCoverTile";
import { MortgageType } from "../models/PortalMortgageModel";

interface IProps {
  isPurchaser?: boolean;
  homeValue?: number;
  existingMortgage?: number;
  remainingTerm?: number;
  repayments?: number;
  interestRate?: number;
  subtitle?: any;
}

interface IState {
  hasError: boolean;
  errors?: string[];
  homeValue?: number | null;
  existingMortgage: number | null;
  remainingTerm: number | null;
  repayments?: number;
  interestRate?: number;
  exploreOptions: boolean;
  showSavings: boolean;
  calculationResult?: ICalculationResult;
  calculatingResults: boolean;
  ber: string | null;
  cashbackOnly: boolean;
  showBooking: boolean;
}

export class MortgageCalculator extends UserContextComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    const context = this.getContext();
    this.state = {
      calculatingResults: false,
      hasError: false,
      homeValue: this.props.homeValue ?? null,
      existingMortgage: this.props.existingMortgage ?? null,
      ber: null,
      exploreOptions: false,
      showSavings: false,
      remainingTerm: this.props.remainingTerm ?? 25,
      cashbackOnly: false,
      showBooking: false,
    };
    this.calculateRepayments = this.calculateRepayments.bind(this);
    this.calculateRepaymentsDelayed =
      this.calculateRepaymentsDelayed.bind(this);
    this.pageRefreshListener = this.pageRefreshListener.bind(this);
  }

  componentDidMount(): void {
    const context = this.getContext();
    context.setPageRefreshListener(this.pageRefreshListener);
    if (
      context?.mortgage?.mortgageAmountProposed ||
      context?.mortgage?.propertyValue ||
      context?.mortgage?.purchasePrice
    ) {
      this.setState({
        existingMortgage: context?.mortgage?.mortgageAmountProposed,
        homeValue:
          context?.mortgage?.propertyValue ?? context?.mortgage?.purchasePrice,
      });
      this.calculateRepaymentsDelayed();
    }
  }

  pageRefreshListener(): void {
    const context = this.getContext();

    if (
      (context.calculatorState.homeValue &&
        context.calculatorState.homeValue !== this.state.homeValue) ||
      (context.calculatorState.mortgageAmount &&
        context.calculatorState.mortgageAmount !==
          this.state.existingMortgage) ||
      (context.calculatorState.mortgageTerm &&
        context.calculatorState.mortgageTerm != this.state.remainingTerm) ||
      (context.calculatorState.berRating &&
        context.calculatorState.berRating !== this.state.ber) ||
      (context.calculatorState.cashbackOnly !== undefined &&
        context.calculatorState.cashbackOnly !== this.state.cashbackOnly)
    ) {
      this.setState({
        homeValue: context.calculatorState.homeValue || this.state.homeValue,
        existingMortgage:
          context.calculatorState.mortgageAmount || this.state.existingMortgage,
        remainingTerm:
          context.calculatorState.mortgageTerm || this.state.remainingTerm,
        ber: context.calculatorState.berRating || this.state.ber,
        cashbackOnly: context.calculatorState.cashbackOnly || false,
      });

      this.calculateRepaymentsDelayed();
    }
  }

  calculateRepaymentsDelayed() {
    setTimeout(this.calculateRepayments, 500);
  }

  calculateRepayments() {
    const context = this.getContext();
    var homeValue = this.state.homeValue;
    var existingMortgage = this.state.existingMortgage;
    var term = this.state.remainingTerm;
    var repayments = this.state.repayments;
    var interestRate = this.state.interestRate;
    var ber = this.state.ber;
    if (!homeValue || !existingMortgage || !term) {
      return;
    }

    if (existingMortgage / homeValue > 0.9) {
      var errors: string[] = [];
      errors.push(
        "Mortgage amount required cannot be greater than 90% of the property value"
      );
      //this.setState({errors: errors, hasError: true, showSavings: false, existingMortgage: Math.round(this.state.homeValue * 0.9)});
      this.setState({ errors: errors, hasError: true, showSavings: false });
      return;
    }

    this.setState({ calculatingResults: true, errors: [], hasError: false });

    var request: ISwitcherCalculationRequest = {
      purchasePrice: homeValue,
      mortgageAmount: existingMortgage,
      term: term,
      interestRate: interestRate!,
      repayments: repayments!,
      ber: ber!,
      cashbackOnly: !!context.calculatorState.cashbackOnly,
    };

    if (context.mortgage?.type === MortgageType.RemortgagingExistingLoan) {
      //AxiosRequestConfig;
      axios({
        url: "/Calculator/CalculateSwitcher",
        method: "post",
        baseURL: process.env.REACT_APP_PUBLIC_API_URL,
        data: request,
      })
        .then((response: { data: any }) => {
          this.setState({
            calculatingResults: false,
            calculationResult: response.data,
            showSavings: true,
          });
        })
        .catch(() => {
          this.setState({ calculatingResults: false });
          //alert('submit error: ' + error.message);
        });
      // this.setState({checking: true});
    } else {
      var purchaseRequest: IRepaymentCalculationRequest = {
        purchasePrice: homeValue,
        mortgageAmount: existingMortgage,
        term: term,
        ber: ber!,
        cashbackOnly: this.state.cashbackOnly,
      };
      axios({
        url: "/Calculator/CalculateRepayment",
        method: "post",
        baseURL: process.env.REACT_APP_PUBLIC_API_URL,
        data: request,
      })
        .then((response) => {
          var showResults = response.data.products.length > 0;
          this.setState({
            calculatingResults: false,
            calculationResult: response.data,
            showSavings: true,
          });
        })
        .catch((error) => {
          this.setState({ calculatingResults: false });
          //alert('submit error: ' + error.message);
        });
    }
  }

  fixedYearText(product: ILenderProduct): any {
    var rateText = "";
    if (!product) return "";
    if (product.fixedYears > 0) {
      rateText = `${product.fixedYears} year, ${product.type}`;
      if (rateText.endsWith("rate")) {
        rateText = rateText.replace("rate", "");
      }
    } else {
      rateText = product.type;
    }
    return rateText;
  }

  render() {
    const context = this.getContext();
    var rates = [{}];
    if (this.state.calculationResult?.products) {
      this.state.calculationResult.products.map(
        (p: ILenderProduct, i: number) => {
          return rates.push(p);
        }
      );
    }
    return (
      <PortalPage
        title={<>Hey {context.contact?.firstName}</>}
        description={
          <>
            <p className="nowrap desktop-only">
              Based on the information supplied, we have set out below some
              initial mortgage options for your review.
              <br />
              <strong>The next step</strong> is to understand your exact
              requirements so we can identify the best mortgage for you.
            </p>
            <p className="mobile-only m">
              Based on the information supplied, we have set out below some
              initial mortgage options for your review.
            </p>
          </>
        }
        alignTitleLeft={true}
        containerClassName={"wide-portal-page"}
      >
        <Container className="pe-0 me-0">
          {
            <>
              <Row
                className="sticky-div bg-limestone"
                style={{ width: "calc(100%+ + 10px)" }}
              >
                {/* Desktop version */}
                <Row className="desktop-only pe-0">
                  <Col
                    className={`ms-2 me-0 box-teal-outline-1 box-chartreuse p-3 text-start`}
                  >
                    <h3 className="impact">Let's keep going!</h3>
                    <p className="mt-2">
                      Or continue to provide more information online to help
                      your advisor to tailor options for you.{" "}
                    </p>
                    <Row>
                      <Link to="/profile" className="">
                        <button className="btn btn-xxl-wide bigger btn-dark chartreuse-font ps-3 text-start">
                          <i className="far fa-circle-right fa-xl pe-2" />{" "}
                          <strong>Continue</strong> online
                        </button>
                      </Link>
                    </Row>
                  </Col>

                  <Col
                    className={`ms-2 me-0 box-teal-outline-1 bg-white p-3 text-start`}
                  >
                    <h3 className="impact">Speak to an expert!</h3>
                    <p className="">
                      Book a call with your advisor to discuss your initial
                      requirements & options
                    </p>
                    <Row className="px-3">
                      <Link to="#" className="p-0">
                        <button
                          className="btn btn-primary btn-xxl-wide bigger btn-standard nowrap ps-3 text-start"
                          disabled={
                            !context.mortgage?.owner?.bookingCalendarLink
                          }
                          onClick={() => {
                            this.setState({ showBooking: true });
                          }}
                        >
                          <i className="far fa-calendar-days fa-xl pe-2" /> Book
                          a call with your advisor
                        </button>
                      </Link>
                    </Row>
                  </Col>
                </Row>

                {/* Mobile version */}
                <Row className={`mobile-only`}>
                  <Row
                    className={`ms-2 me-0 box-teal-outline-1 box-chartreuse p-3 text-center`}
                  >
                    <h3 className="impact">Let's keep going!</h3>
                    <p className="m">
                      Book a call with your advisor to discuss your initial
                      requirements & options
                    </p>
                    <Row className="px-3">
                      <Link to="#" className="p-0">
                        <button
                          className="btn btn-primary btn-xxl-wide bigger btn-standard nowrap ps-3 text-start"
                          onClick={() => {
                            this.setState({ showBooking: true });
                          }}
                        >
                          <i className="far fa-calendar-days fa-xl pe-2" /> Book
                          a call with your advisor
                        </button>
                      </Link>
                    </Row>

                    <p className="mt-2 m">
                      Or continue to provide more information online to help
                      your advisor to tailor options for you.{" "}
                    </p>
                    <Row>
                      <Link to="/profile" className="p-0">
                        <button className="btn btn-xxl-wide bigger btn-dark chartreuse-font ps-3 text-start">
                          <i className="far fa-circle-right fa-xl pe-2" />{" "}
                          <strong>Continue</strong> online
                        </button>
                      </Link>
                    </Row>
                  </Row>
                </Row>
              </Row>
              <Row style={{ width: "100%" }}>
                <Row className={`desktop-only m-2 px-3 py-4 justify-center`}>
                  <p>
                    <strong>Remember, </strong>we work with all major mortgage
                    lenders.
                    <br />
                    Your free mortgage advisor will work with you to secure the
                    best lender for you.
                  </p>
                  <div className="lenders"></div>
                </Row>
                <Row className={`mobile-only m-2 px-3 pt-2 justify-center`}>
                  <p className="xs">
                    <strong>Remember, </strong>we work with all major mortgage
                    lenders.
                    <br />
                    Your free mortgage advisor will work with you to secure the
                    best lender for you.
                  </p>
                  <div className="lenders s"></div>
                </Row>
              </Row>
            </>
          }

          {this.state.showSavings && this.state.calculationResult?.products && (
            <>
              {this.state.calculationResult.products.map(
                (item: ILenderProduct, index: number) => {
                  return (
                    <div key={`product-${index}`}>
                      {/* {index === 2 && (
                        <Row style={{ width: "100%" }}>
                          <Row className={`m-2 px-3 py-4 justify-center`}>
                            <p>
                              <strong>Remember, </strong>we work with all major
                              mortgage lenders.
                              <br />
                              Your free mortgage advisor will work with you to
                              secure the best lender for you.
                            </p>
                            <div className="desktop-only lenders"></div>
                          </Row>
                        </Row>
                      )} */}
                      <Row style={{ width: "100%" }} className="me-0 pe-0">
                        <CalculatedLenderProductRow
                          item={item}
                          repayment={this.state.calculationResult?.repayment}
                        />
                      </Row>
                    </div>
                  );
                }
              )}
            </>
          )}

          <div className="mobile-only mt-3">
            <button
              className="btn btn-third"
              onClick={() => {
                // Admittedly a bit of a hack, but I can't find a better way to open this
                var nav: any =
                  document.getElementsByClassName("navbar-toggler");
                if (nav?.length > 0) nav[0].click();
                window.scrollTo(0, 0);
              }}
            >
              Update your requirement <i className="fas fa-filter" />
            </button>
          </div>

          {context.mortgage?.type === MortgageType.RemortgagingExistingLoan && (
            <Row className="mt-5 ps-2 text-start" style={{ marginLeft: -30 }}>
              <h1>What's next?</h1>
              <div className="boxty tall grid box-chartreuse m-3 text-start">
                <h3 className="pb-3">Complete your application</h3>
                <p>
                  Glide through all the mandatory information requited and
                  upload the all the mandatory documents.
                </p>
                <p>Your advisor will help you select the best loan for you.</p>
                <Link to="/profile" className=" a-s-e">
                  <button className="btn fw big btn-dark next chartreuse-font pe-5 mt-3">
                    Complete application
                  </button>
                </Link>
              </div>
              {!context.mortgage?.solicitor && <AppointSolicitorTile />}
              {!context.mortgage?.hasInsuranceQuote && <LifeCoverTile />}
            </Row>
          )}
        </Container>
        <Modal
          size="lg"
          fullscreen="lg-down"
          show={this.state.showBooking}
          centered
          onHide={() => this.setState({ showBooking: false })}
        >
          <ModalHeader closeButton className="-mt-2"></ModalHeader>
          <ModalBody
            style={{ background: "transparent", height: "calc(100vh - 100px)" }}
          >
            <iframe
              src={context.mortgage?.owner?.bookingCalendarLink ?? ""}
              width="100%"
              //height="100%"
              scrolling="yes"
              style={{ border: 0, height: "calc(100% - 40px)", marginTop: 20 }}
            ></iframe>
          </ModalBody>
        </Modal>
      </PortalPage>
    );
  }
}
